export const OKTA_GROUPS = {
  ADVISER: window.LM_CONFIG.OKTA_ADVISER_GROUP_NAME,
  CORPORATE: window.LM_CONFIG.OKTA_CORPORATE_GROUP_NAME,
};
